import app from '@/app';

/* @ngInject */
function stateConfig($stateProvider, stateHelperProvider) {
	var states = [
		{
			name: 'materialsServices',
			parent: 'entity',
			url: '/materialsServices/organization&unit&name&page&sort',
			component: 'materialsServicesSearch',
			data: {
				viewAuthorities: ['ENTITIES_READ', 'METRICLIMIT_READ'],
				editAuthorities: ['ENTITIES_WRITE', 'METRICLIMIT_WRITE']
			},
			params: {
				organization: {
					type: 'int',
					value: null,
					squash: true,
					dynamic: true
				},
				unit: {
					value: null,
					squash: true,
					dynamic: true
				},
				name: {
					value: null,
					squash: true,
					dynamic: true
				},
				page: {
					value: 0,
					type: 'int',
					squash: true,
					dynamic: true
				},
				sort: {
					value: 'name,asc',
					squash: true,
					dynamic: true
				}
			}
		},
		{
			name: 'materialsServices.detail',
			url: '/{id}',
			component: 'materialsServicesDetail',
			resolve: {
				/* @ngInject */
				entity: (MaterialsServices, $transition$, entityInjector) =>
					entityInjector(MaterialsServices, $transition$.params().id)
			}
		}
	];
	states.forEach(state => $stateProvider.state(state));
}

app.config(stateConfig);
